<template>
    <div>
        <div class="card shadow p-0 m-0">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.medicalManagement') }}
                    </h3>
                </div>
            </div>
            <div class="card-body px-0">
                <div class="row" v-if="hasAdminRole || hasMedecinControleRole || hasPraticienRole || hasPatientRole || hasSouscripteurRole || hasAssistante">
                    <b-container class="px-0">
                        <b-row class="p-0 m-0">
                            <b-col col sm="12">
                                <h3 class="text-center" v-if="!hasPatientRole && !hasSouscripteurRole"> {{$t('message.searchPatient')}}</h3>
                                <h3 class="text-center" v-else> {{$t('message.listOfAffilaites')}}</h3>

                                <section class="container-fluid p-0 m-0" id="appointment-table">
                                    <div class="appointment-table-header my-2 mb-4 p-0 m-0">
                                        <div class="row p-0 m-0">
                                            <div class="col-12">
                                                <b-input-group
                                                    class="mb-3"
                                                >
                                                    <b-form-input
                                                            type="text"
                                                            class="p-2"
                                                            :placeholder="$t('message.search') + '...'"
                                                            v-model="filterCriteria"
                                                    ></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button
                                                                size="sm"
                                                                text="Button"
                                                                variant="primary"
                                                                @click="handlerOnFilterButton"
                                                        >
                                                            Go
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-3">
                                                <div class="ml-1">
                                                    <div class="d-flex">
                                                        <b-form-select
                                                                class="d-inline-block mr-2"
                                                                v-model="sortSelected"
                                                                size="sm"
                                                                :options="sortOptions"></b-form-select>

                                                        <div>
                                                            <b-button-group size="sm" class="mr-1">
                                                                <b-button
                                                                        :disabled="sortDirection === 'asc'"
                                                                        class="btn"
                                                                        size="sm"
                                                                        @click="sortDirection='asc'"
                                                                >
                                                                    <i class="fa fa-sort-amount-up-alt"></i>
                                                                </b-button>
                                                                <b-button
                                                                        :disabled="sortDirection === 'desc'"
                                                                        class="btn"
                                                                        size="sm"
                                                                        @click="sortDirection='desc'"
                                                                >
                                                                    <i class="fa fa-sort-amount-down-alt"></i>
                                                                </b-button>
                                                            </b-button-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-9 overflow-auto">
                                                <div class="ml-1">
                                                    <div
                                                            v-if="paginationObject.numOfPages > 1"
                                                            class="pagination-wrapper d-inline-block"
                                                    >
                                                        <div class="pagination">
                                                            <a
                                                                    href="#"
                                                                    :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                    @click="_handlePaginationClick('prev')"
                                                            >
                                                                <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                            </a>
                                                            <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                                <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                                </template>
                                                                <template v-else>
                                                                    <a
                                                                            href="#"
                                                                            :key="key"
                                                                            class="page-numbers"
                                                                            @click="_handlePaginationClick(pageNumber)"
                                                                    >
                                                                        {{ pageNumber }}
                                                                    </a>
                                                                </template>
                                                            </template>
                                                            <a
                                                                    href="#"
                                                                    class="next page-numbers"
                                                                    :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                    @click="_handlePaginationClick('next')"
                                                            >
                                                                <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row appointment-table-content">
                                        <div class="container-fluid">
                                            <template
                                                    v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0"
                                            >
                                                <div
                                                        v-for="(patient, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                        :key="key"
                                                        class="row appointment-item hovered"
                                                        @click="onPatientClick({row: patient})"
                                                >
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $tc('message.patients', 1) }}
                                                        </span>
                                                        <h4 class="appointment-date">{{ patient.nom }}</h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.fileNumber') }}
                                                        </span>
                                                        <h4 class="appointment-hour">
                                                            {{ patient.dossier }}
                                                        </h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.old') }}
                                                        </span>
                                                        <h4 class="appointment-hour">
                                                            {{ patient.age }}
                                                        </h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.email') }}
                                                        </span>
                                                        <h4 class="appointment-hour">
                                                            {{ patient.email }}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                            </template>

                                        </div>
                                    </div>
                                </section>

                                <!--<div class="vgt-global-search vgt-clearfix">
                                    <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                        <div class="magnifying-glass">

                                        </div>
                                    </span>
                                        <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                                    </div>
                                    <div class="vgt-global-search__actions vgt-pull-right">

                                    </div>
                                </div>
                                <vue-good-table
                                        id="operation"
                                        :columns="patientsColumns"
                                        :rows="hasPatientRole || hasSouscripteurRole ? mPatients : mPatientsFilter"
                                        :search-options="{
                                        enabled:true,
                                        externalQuery: searchTerm
                                        }"
                                        :pagination-options="paginationOptions"
                                        @on-row-click="onPatientClick"
                                />-->
                            </b-col>
                        </b-row>
                    </b-container>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';
    import Swal from 'sweetalert2';
	import {pagination, handlePaginationClick, paginationDataProperty} from "../helpers/paginations";

    export default {
        name: "MedicalManagement",
        computed: {
            ...mapGetters([
                "selectedInstitution",
                "userInstitutions",
                "institutions",
                "patients",
                'hasAdminRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'hasPatientRole',
                'hasPraticienRole',
                'hasSouscripteurRole',
                'hasGestionnaireRole']),

            
        },

        data() {
            return {
				...paginationDataProperty(this.$i18n),

				shouldDisplay: false,

                etablissementsColumns: [
                    {
                        label: this.$i18n.t('message.name'),
                        field: 'nom',
                    },
                    {

                        label: this.$i18n.t('message.description'),
                        field: 'description'
                    },
                ],

                patientsColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'nom',
                    },
                    {
                        field: 'dossier',
                        label: this.$i18n.t('message.fileNumber')
                    },
                    {
                        field: 'age',
                        label: this.$i18n.t('message.old')
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email')
                    },
                ],

                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled: {enabled: true},

                searchTerm : '',

                mPatientsFilter : [],
            }
        },
        watch:{
            searchTerm:function (newValue, oldValue) {
                if (!this.hasPatientRole){
                    if (newValue.trim().length ==0){
                        this.mPatientsFilter = [];
                    }else{
                        this.mPatientsFilter = this.mPatients;
                    }
                }else{
                    this.mPatientsFilter = this.mPatients;
                }
            },

			patients: function (newValue, oldValue) {
				if (!this.shouldDisplay) {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
				} else {
					this.currentPatientArray = this.mPatients();
					this.currentPatientArrayFiltered = this.currentPatientArray;
				}
			},

			currentPatientArray: function (newValue, oldValue) {
				this.paginationObject = pagination(newValue);
			},

			filterCriteria: async function (newValue, oldValue) {
            	//console.log("on est ici maintenant?");
                //console.log(newValue);
				if (newValue.length >= 3) {
                    await this.getSearchPatient(newValue)
                    if(!this.shouldDisplay)
					    this.shouldDisplay = true;
                    
                    this.currentPatientArray = this.mPatients();
					this.currentPatientArrayFiltered = this.currentPatientArray;
                    
					this.handleFilter(newValue);
                    
                    
				}
                if (newValue.length > 1) {
                    // await this.getSearchPatient(newValue)
                    //     console.log(this.patients);
                    if(!this.shouldDisplay)
					    this.shouldDisplay = true;
                    
                    // this.currentPatientArray = this.mPatients();
					// this.currentPatientArrayFiltered = this.currentPatientArray;
                    
					this.handleFilter(newValue);
                    
                    
				}
			},

			sortDirection: function (newValue, oldValue) {
				this.handleSort(this.sortSelected ,newValue);
			},

			sortSelected: function (newValue, oldValue) {
				this.handleSort(newValue, this.sortDirection);
			},

            shouldDisplay: function (newValue, oldValue) {
                if (newValue) {
					this.currentPatientArray = this.mPatients();
					this.currentPatientArrayFiltered = this.currentPatientArray;
                } else {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
                }
			}
        },

        methods:{
            hasSelectInstitution() {
                return _.isNull(this.selectedInstitution) || _.isEmpty(this.selectedInstitution);
            },

            mPatients() {
                let pArray = [];
                if (this.hasPatientRole){
                    
                    if (!_.isEmpty(this.patients)) {
                        // if (!_.isEmpty(this.institutions[0].patients)){
                        let patient = this.patients[0];
                        let p = {};

                        if (typeof patient.user == 'object') {
                            if (!_.isUndefined(patient.dossier)) {
                                if (!_.isNull(patient.dossier) && !_.isNull(patient.user)) {
                                    let prenom = patient.user.prenom ? patient.user.prenom : '';
                                    prenom =  prenom.toLowerCase();
                                    p.nom =  (patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                                    p.dossier = patient.dossier.numero_dossier;
                                    p.email = patient.user.email;
                                    p.telephone = patient.user.telephone;
                                    p.age = patient.age;
                                    p.nationalite = patient.user.nationalite;
                                    p.ville = patient.user.ville;
                                    p.pays = patient.user.pays;
                                    p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                                    p.id = patient.user.id;
                                    p.slug = patient.user.slug;
                                    p.adresse = patient.user.adresse;
                                    p.fileSlug = patient.dossier.slug;

                                    pArray.push(p);
                                }
                            }

                            // }

                            return pArray;
                        }
                        return pArray;

                    }
                }
                else if(this.hasSouscripteurRole){
                    let pArray = [];
                    _.forEach(this.patients, function(patient) {
                        let p = {};
                        if (typeof patient.user == 'object') {
                            if (!_.isUndefined(patient.dossier)){
                                if (!_.isNull(patient.dossier) && !_.isNull(patient.user)){
                                    let prenom = patient.user.prenom ? patient.user.prenom : '';
                                    prenom =  prenom.toLowerCase();
                                    p.nom =  (patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                                    p.dossier = patient.dossier.numero_dossier;
                                    p.email = patient.user.email;
                                    p.telephone = patient.user.telephone;
                                    p.age = patient.age;
                                    p.nationalite = patient.user.nationalite;
                                    p.ville = patient.user.ville;
                                    p.pays = patient.user.pays;
                                    p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                                    p.id = patient.user.id;
                                    p.slug = patient.user.slug;
                                    p.adresse = patient.user.adresse;
                                    p.fileSlug = patient.dossier.slug;

                                    pArray.push(p);
                                }
                            }

                        }
                    });
                    return pArray;
                }
                else{
                    // let institutions = [];
                    // if(!_.isNull(this.selectedInstitution) && !_.isEmpty(this.selectedInstitution)) {
                    //     institutions = this.selectedInstitution;
                    // }
                    // else{
                    //     institutions = this.institutions;
                    // }
                    // _.forEach(institutions, function(institution) {
                        // if(typeof institution.patients == "object"){
                            _.forEach(this.patients, function(patient) {
                                let p = {};
                                if (typeof patient.user == 'object') {
                                    if (!_.isUndefined(patient.dossier)){
                                        if (!_.isNull(patient.dossier) && !_.isNull(patient.user)){
                                            let prenom = patient.user.prenom ? patient.user.prenom : '';
                                            prenom =  prenom.toLowerCase();
                                            p.nom =  (patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                                            p.dossier = patient.dossier.numero_dossier;
                                            p.email = patient.user.email;
                                            p.telephone = patient.user.telephone;
                                            p.age = moment().year() - moment(patient.date_de_naissance).year();
                                            p.nationalite = patient.user.nationalite;
                                            p.ville = patient.user.ville;
                                            p.pays = patient.user.pays;
                                            p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                                            p.id = patient.user.id;
                                            p.slug = patient.user.slug;
                                            p.adresse = patient.user.adresse;
                                            p.fileSlug = patient.dossier.slug;
                                            // p.institutionId = institution.id;
                                            if(!_.isUndefined(patient.etablissements[0]))
                                                p.institutionId = patient.etablissements[0].id;
                                            let hasPatient =  _.filter(pArray,function (item) {
                                                if(item.dossier == p.dossier)
                                                    return p;
                                            })
                                            if(_.isEmpty(hasPatient)){
                                                pArray.push(p);
                                            }
                                        }
                                    }

                                }
                            });
                    //     }

                    // });
                    // }
                    return pArray;
                }
                return pArray;
            },

            mInstitutions() {
                let iArray = [];
                // let self = this;
                _.forEach(this.institutions, function(institution) {
                    // if(typeof institution.patients == "object"){
                    //     _.forEach(institution.patients, function(patient) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = institution.description;
                    i.etablissementId = institution.id;
                    // i.id = institution.id + patient.user_id;
                    i.slug = institution.slug;
                    // i.pnom = self.formatString((patient.user.prenom ? ' ' + patient.user.prenom : '') + "  " + (patient.user.nom).toUpperCase() ) + " ( "
                    //     +patient.dossier.numero_dossier + " )";
                    // i.pslug = patient.slug;
                    iArray.push(i);
                });
                // }

                // });

                return iArray;
            },

            mUserInstitutions() {
                let iArray = [];
                // let self = this;
                _.forEach(this.userInstitutions, function(institution) {
                    // if(typeof institution.patients == "object"){
                    //     _.forEach(institution.patients, function(patient) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = institution.description;
                    i.etablissementId = institution.id;
                    i.id = institution.id;
                    i.slug = institution.slug;
                    i.patients = institution.patients;
                    // i.pnom = self.formatString((patient.user.prenom ? ' ' + patient.user.prenom : '') + "  " + (patient.user.nom).toUpperCase() ) + " ( "
                    //     +patient.dossier.numero_dossier + " )";
                    // i.pslug = patient.slug;
                    iArray.push(i);
                });
                // }

                // });
                return iArray;
            },

			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
			},

			handleFilter(value) {
				if (value) {
                    // await this.getSearchPatient(value);
                    // console.log(this.patients);
                    // this.currentPatientArray=this.patients;
                    // this.currentPatientArrayFiltered = this.currentPatientArray;
                    if(value.length==1){
                        const newCurrentPatientArray=this.currentPatientArray;

                        this.currentPatientArrayFiltered = newCurrentPatientArray;

					    this.paginationObject = pagination(newCurrentPatientArray);
                    }
                    
                    if(value.length>1){
                        const newCurrentPatientArray = this.currentPatientArray.filter(app => {
                            let result = false;

                            if (app.nom) {
                                result = result || app.nom.toLowerCase().includes(value.toLowerCase());
                            }

                            if (app.dossier) {
                                result = result || app.dossier.toString().toLowerCase().includes(value.toLowerCase());
                            }

                            if (app.age) {
                                result = result || app.age.toString().toLowerCase().includes(value.toLowerCase());
                            }

                            if (app.email) {
                                result = result || app.email.toLowerCase().includes(value.toLowerCase());
                            }

                            return result;
                        });

                        this.currentPatientArrayFiltered = newCurrentPatientArray;

                        this.paginationObject = pagination(newCurrentPatientArray);
                    }
					
					
				} else {
					this.currentPatientArrayFiltered = this.currentPatientArray;
					this.paginationObject = pagination(this.currentPatientArray);
				}
			},

			handleSort(value, sortDirection = 'asc') {
				if (value) {
					let newCurrentPatientArray = [];
					const sortType = ['nom', 'dossier', 'age', 'email'];
					const restOfType = sortType.filter(i => i !== value);

					const sortDirectionType = ['asc', 'desc'];
					const restOfSortDirectionType = sortDirectionType.filter(i => i !== sortDirection);

					newCurrentPatientArray = _.orderBy(this.currentPatientArrayFiltered, [value, ...restOfType], [sortDirection, ...restOfSortDirectionType]);

					this.paginationObject = pagination(newCurrentPatientArray);
				} else {
					this.paginationObject = pagination(this.currentPatientArrayFiltered);
				}
			},


			onEtablissementClick(params){
                let etablissementId = params.row.etablissementId;
                let etablissement = _.filter(this.institutions,function (institution) {
                    return institution.id == etablissementId;
                });
                this.$store.dispatch('setselectedInstitution', { selectedInstitution : etablissement });
            },

            formatString(item){
                return item.length > 36 ? item.substr(0, 36) + '...' : item;
            },

            async getSearchPatient(value) {
                let args = {
                    patient: value
                };

                await this.$store.dispatch("getSearchPatient", {
                    args : args
                });
            },

            getInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getInstitutions', { args : args });
            },

            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            onPatientClick(params){
                let isPraticienPatient=_.find(this.mUserInstitutions,function (institution) {
                    let patient = _.find(institution.patients, function (patient) {
                        return  patient.user_id == params.row.id;
                    });
                    if(_.isUndefined(patient))
                        return patient;
                    return institution;
                });

                if(!this.hasPatientRole && !this.hasSouscripteurRole){
                    if (_.isUndefined(isPraticienPatient)){
                        Swal.fire({
                            title: 'Êtes vous sûr ?',
                            text: "Ce patient n'appartient pas à l'un de vos établissements. Vous serez fichié dans le système si vous y accédez",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#00ada7',
                            cancelButtonColor: '#f5365c',
                            confirmButtonText: 'Oui, accéder!'
                        }).then((result) => {
                            if (result.value) {
                                // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                                this.$router.push( (this.$router.resolve({ name: 'medical-file',  params: { file: params.row.fileSlug  } })).href +  '#generale');

                            }
                        })
                    }else{
                        // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                        this.$router.push( (this.$router.resolve({ name: 'medical-file',  params: { file: params.row.fileSlug  } })).href +  '#generale');

                    }
                }else{
                    // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                    this.$router.push((this.$router.resolve({ name: 'medical-file',  params: { file: params.row.fileSlug  } })).href +  '#generale');

                }

            },

            notEmpty(item){
                return item.length > 0;
            },

            getPatients() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPatients', { args : args });
            },
        },
        mounted() {
            this.currentPatientArray = [];
			this.currentPatientArrayFiltered = [];
            // Fetch institution list
            // this.getInstitutions();

            // Fetch user institution list
            // this.getUserInstitutions();

            // // Fetch patient list
            // this.getPatients();

        }
    }
</script>

<style scoped>

</style>
